export const Animation = {

	TYPE_SLIDE_OVER: "SLIDE_OVER",

	/**
	 * Will start the animation process for a view
	 * @param {{Root: Element, routeData: Object, Element: Element, navBack: Boolean}} options
	 */
	initialize: (options) => {
		// choose what animation to play
		switch (options.routeData.animate) {
			case Animation.TYPE_SLIDE_OVER: Animation.SlideOverDirection(options);
		}
	},

	/**
	 *
	 * @param {{Root: Element, routeData: Object, Element: Element, navBack: Boolean}} options
	 * @constructor
	 */
	SlideOverDirection: (options) => {
		if (!options.navBack) Animation.SlideOverLeft(options);
		else Animation.SlideOverRight(options);
	},

	/**
	 * Will animation a page from right to left
	 * @param {{Root: Element, routeData: Object, Element: Element, navBack: Boolean}} route
	 * @constructor
	 */
	SlideOverLeft: (route) => {

		// get the last page rendered to the root
		const lastPage = route.Root.firstChild;

		// check if there was a page rendered to the root before
		if (lastPage) {
			// style the root element
			const Root = route.Root;
			Root.style.position = "relative";
			Root.style.overflowX = "hidden";

			// style the element to bbe rendered
			const Element = route.Element;
			Element.style.position = "relative";
			Element.style.top = "0";
			Element.style.left = "100%";

			// style the ald element
			lastPage.style.position = "absolute";
			lastPage.style.top = "0";
			lastPage.style.left = "0";

			// render the new element with it's new styles
			Root.appendChild(Element);

			// apply the animation
			Element.animate([
				{left: 0}
			], {
				duration: 400,
				easing: 'ease-in',
				fill: "forwards"
			});

			// apply the animation
			lastPage.animate([
				{left: "-100%"}
			], {
				duration: 400,
				easing: 'ease-in',
				fill: "forwards"
			});

			setTimeout(() => {
				Element.style = false;
				lastPage.remove();
			}, 400);
		}
		else {
			route.Root.innerHTML = "";
			route.Root.appendChild(route.Element);
			$ActiveJS.initialRenderFinished = true;
		}
	},

	/**
	 * Will animation a page from right to left
	 * @param {{Root: Element, routeData: Object, Element: Element, navBack: Boolean}} route
	 * @constructor
	 */
	SlideOverRight: (route) => {

		// get the last page rendered to the root
		const lastPage = route.Root.firstChild;

		// check if there was a page rendered to the root before
		if (lastPage) {
			// style the root element
			const Root = route.Root;
			Root.style.position = "relative";
			Root.style.overflowX = "hidden";

			// style the element to bbe rendered
			const Element = route.Element;
			Element.style.position = "absolute";
			Element.style.top = "0";
			Element.style.left = "-100%";

			// style the ald element
			lastPage.style.position = "relative";
			lastPage.style.top = "0";
			lastPage.style.left = "0";

			// render the new element with it's new styles
			Root.prepend(Element);

			// apply the animation
			Element.animate([
				{left: 0}
			], {
				duration: 400,
				easing: 'ease-in',
				fill: "forwards"
			});

			// apply the animation
			lastPage.animate([
				{left: "100%"}
			], {
				duration: 400,
				easing: 'ease-in',
				fill: "forwards"
			});

			setTimeout(() => {
				Element.style = false;
				lastPage.remove();
			}, 400);
		}
		else {
			route.Root.innerHTML = "";
			route.Root.appendChild(route.Element);
			$ActiveJS.initialRenderFinished = true;
		}
	},

};